import React from "react";
import ConveniosYearPage from "./ConveniosYearPage";
import { convenios2022 } from "../../../../data/Convenios/dataConvenios";

const Convenios2022 = () => <ConveniosYearPage year={2022} data={convenios2022} />;

export default Convenios2022;